import { AriaMark } from "@/components/AriaMark";
import { ChatTab } from "@/components/aria/ChatTab";
import { TasksTab } from "@/components/aria/TasksTab";
import { AuditTab } from "@/components/aria/AuditTab";
import { X, Activity, Maximize2, Minimize2, MessageSquare, ScrollText, MousePointerClick } from "lucide-react";

const SUB_TABS = [
  { key: "chat", label: "Chat", icon: MessageSquare },
  { key: "tasks", label: "Running Tasks", icon: Activity },
  { key: "audit", label: "Audit", icon: ScrollText },
];

export const AriaPanel = ({
  chat, pageName, suggestions,
  selectMode, toggleSelectMode, selection, setSelection,
  expanded, onToggleExpand, onClose,
}) => {
  const runningCount = chat.missions.filter((m) => m.state === "running").length;

  return (
    <div className="flex h-full min-h-0 flex-col">
      {/* header */}
      <div className="flex items-center gap-2.5 border-b border-[#1e1e1e] px-4 py-3">
        <AriaMark size={26} />
        <div className="min-w-0">
          <div className="flex items-center gap-2 text-[13px] font-medium leading-none">
            Aria
            <span className="rounded-md bg-[rgba(79,142,247,0.14)] px-1.5 py-[1px] text-[9.5px] font-medium text-[#7FAEF9]" data-testid="ask-aria-context">
              {pageName}
            </span>
          </div>
          <div className="mt-1 flex items-center gap-1 text-[10px] text-[#4ADE80]">
            <span className="h-1 w-1 rounded-full bg-[#22C55E] pulse-dot" /> online · sees this page
          </div>
        </div>
        <div className="ml-auto flex items-center gap-1">
          <button onClick={toggleSelectMode} data-testid="ask-aria-select-toggle" title="Select objects on screen for Aria to act on"
            className={`flex h-7 items-center gap-1.5 rounded-lg px-2 text-[11px] font-medium transition-colors ${
              selectMode ? "bg-[rgba(79,142,247,0.2)] text-[#7FAEF9]" : "text-[#A3A3A3] hover:bg-[#1c1c1c] hover:text-white"
            }`}>
            <MousePointerClick size={13} /> Select
          </button>
          <button onClick={onToggleExpand} data-testid="ask-aria-expand" title={expanded ? "Collapse" : "Expand"}
            className="flex h-7 w-7 items-center justify-center rounded-lg text-[#A3A3A3] hover:bg-[#1c1c1c] hover:text-white">
            {expanded ? <Minimize2 size={14} /> : <Maximize2 size={14} />}
          </button>
          <button onClick={onClose} data-testid="ask-aria-close"
            className="flex h-7 w-7 items-center justify-center rounded-lg text-[#A3A3A3] hover:bg-[#1c1c1c] hover:text-white">
            <X size={15} />
          </button>
        </div>
      </div>

      {/* sub tabs */}
      <div className="flex gap-1 border-b border-[#1e1e1e] px-3 py-2">
        {SUB_TABS.map(({ key, label, icon: Icon }) => (
          <button key={key} onClick={() => chat.setTab(key)} data-testid={`ask-aria-tab-${key}`}
            className={`flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-[12px] transition-colors ${chat.tab === key ? "bg-[#1c1c1c] text-white" : "text-[#A3A3A3] hover:text-white"}`}>
            <Icon size={12} /> {label}
            {key === "tasks" && runningCount > 0 && (
              <span className="rounded-md bg-[rgba(79,142,247,0.18)] px-1.5 text-[9.5px] tabular-nums text-[#7FAEF9]">{runningCount}</span>
            )}
          </button>
        ))}
      </div>

      {chat.tab === "chat" ? (
        <ChatTab chat={chat} selection={selection} setSelection={setSelection} suggestions={suggestions} pageName={pageName} />
      ) : chat.tab === "audit" ? (
        <AuditTab audit={chat.audit} />
      ) : (
        <TasksTab missions={chat.missions} tasks={chat.tasks} />
      )}
    </div>
  );
};
